import {avatarData} from '../data/avatarData';

export const getAvatarDetails = ( prefix ) => {
  const index = avatarData.findIndex( data => data.prefix === prefix );
  return avatarData[index];
};

export const testFeaturesExist = ( testFeatures ) => {
  let sets = [];

  avatarData.forEach((avatar, i) => {
    sets[i] = true;
    for(let option of avatar.options) {
      if( !testFeatures[option.id] ) {
        sets[i] = false;
        break;
      }
    }
  });
  return sets.some(x => x);
};
